module.exports = __webpack_public_path__ + "img/Unfamiliar.cac5fb99.png";